export const DateFormats = {
  monthDateYear: "MMM dd, yyyy",           // Jul 22, 2026
  fullMonthDateYear: "MMMM dd, yyyy",      // July 22, 2026
  dayMonthYear: "dd-MM-yyyy",              // 22-07-2026
  yearMonthDay: "yyyy-MM-dd",              // 2026-07-22
  dateTime: "MMM dd, yyyy hh:mm a",        // Jul 22, 2026 09:30 AM
  fullDateTime: "dd-MM-yyyy hh:mm a",      // 22-07-2026 09:30 AM
  time: "hh:mm a",                         // 09:30 AM
  dateTimeAt: "yyyy-MM-dd'T'HH:mm",
  iso: "yyyy-MM-dd HH:mm:ss.SSS",    
} as const;